export const INVALID_CONNECTION = 'This connection is not valid.';
